/**
 * Clinics API — the export names the app and tests import. The requests are
 * built once, for camps and clinics alike, in typedEventsAPI.js.
 *
 * Most names say "Camp": this file began as a copy of campsAPI.js and its
 * exports were never renamed. They are kept exactly, because components
 * across the app import them.
 */
import { createTypedEventsAPI } from "./typedEventsAPI";

const api = createTypedEventsAPI("clinic");

export const createCamp = api.createTypedEvent;
export const getCamps = api.getTypedEvents;
export const getCampById = api.getTypedEventById;
export const updateCamp = api.updateTypedEvent;
export const deleteCamp = api.deleteTypedEvent;
export const registerForCamp = api.registerForTypedEvent;
export const getCampRegistrations = api.getTypedEventRegistrations;
export const getMyCampRegistrations = api.getMyTypedEventRegistrations;
export const cancelCampRegistration = api.cancelTypedEventRegistration;
export const getClinicCancellationPreview = api.getTypedEventCancellationPreview;
export const exportCampRegistrations = api.exportTypedEventRegistrations;
export const getCampAttendance = api.getTypedEventAttendance;
export const checkInCampAttendee = api.checkInTypedEventAttendee;
export const checkOutCampAttendee = api.checkOutTypedEventAttendee;
export const markAttendeeAbsent = api.markTypedEventAttendeeAbsent;
export const undoAttendeeCheckIn = api.undoTypedEventCheckIn;
export const duplicateCamp = api.duplicateTypedEvent;
export const getRegistrationQRCode = api.getRegistrationQRCode;
export const validateCampQRCode = api.validateTypedEventQRCode;
export const getCampTemplates = api.getTypedEventTemplates;
export const getCampTemplateById = api.getTypedEventTemplateById;
export const createCampTemplate = api.createTypedEventTemplate;
export const updateCampTemplate = api.updateTypedEventTemplate;
export const deleteCampTemplate = api.deleteTypedEventTemplate;
export const createCampFromTemplate = api.createTypedEventFromTemplate;
export const getCampWaitlist = api.getTypedEventWaitlist;
export const promoteFromWaitlist = api.promoteFromWaitlist;
export const getCampStaff = api.getTypedEventStaff;
export const getAvailableStaff = api.getAvailableStaff;
export const assignCampStaff = api.assignTypedEventStaff;
export const updateCampStaffRole = api.updateTypedEventStaffRole;
export const removeCampStaff = api.removeTypedEventStaff;
export const getAttendanceReport = api.getAttendanceReport;
export const getCampAnalytics = api.getTypedEventAnalytics;
export const getCampStats = api.getTypedEventStats;
export const sendCampReminders = api.sendTypedEventReminders;
export const sendCampNotification = api.sendTypedEventNotification;
export const getDailyUpdates = api.getDailyUpdates;
export const saveDailyUpdate = api.saveDailyUpdate;
export const sendDailyUpdateEmails = api.sendDailyUpdateEmails;
export const createCampPaymentIntent = api.createTypedEventPaymentIntent;
export const confirmCampPayment = api.confirmTypedEventPayment;
export const processCampRefund = api.processTypedEventRefund;
export const getCampPaymentStatus = api.getTypedEventPaymentStatus;
export const adminUpdateCampPaymentStatus = api.adminUpdateTypedEventPaymentStatus;
export const recordClinicRegistrationPayment = api.recordTypedEventRegistrationPayment;
export const getCampPhotos = api.getTypedEventPhotos;
export const addCampPhoto = api.addTypedEventPhoto;
export const addCampPhotos = api.addTypedEventPhotos;
export const updateCampPhoto = api.updateTypedEventPhoto;
export const deleteCampPhoto = api.deleteTypedEventPhoto;
export const setFeaturedCampPhoto = api.setFeaturedTypedEventPhoto;
export const reorderCampPhotos = api.reorderTypedEventPhotos;
export const getCampSupplyList = api.getTypedEventSupplyList;
export const updateCampSupplyList = api.updateTypedEventSupplyList;
export const addSupplyItem = api.addSupplyItem;
export const sendBulkClinicRegistrationEmail = api.sendBulkTypedEventRegistrationEmail;
export const removeSupplyItem = api.removeSupplyItem;
export const adminRegisterForClinic = api.adminRegisterForTypedEvent;

// Batch registration (several participants, one payment) — a capability of
// every typed event since the registration modal became one (Phase B4).
export const batchRegisterForClinic = api.batchRegisterForTypedEvent;
export const confirmBatchClinicPayment = api.confirmBatchTypedEventPayment;
